import React, { useMemo } from "react";
import { MUICustomAutocompleteSelect } from "@/components/muiCustom/select/MUICustomAutocompleteSelect";
import CheckIcon from "@mui/icons-material/Check";

type EmailLocation = {
  id: string | number;
  name: string;
};

type LocationOption = {
  label: string;
  value: EmailLocation["id"];
};

type LocationFilterProps = {
  locations?: EmailLocation[];
  selectedLocation?: EmailLocation["id"] | { id?: EmailLocation["id"] };
  onLocationChange?: (_location?: EmailLocation) => void;
  label?: string;
  className?: string;
};

const LocationFilter = ({
  locations = [],
  selectedLocation,
  onLocationChange,
  label = "Select Location",
  className = "",
}: LocationFilterProps) => {
  const locationOptions = useMemo(() => {
    return locations.map((location) => ({
      label: location.name,
      value: location.id,
    }));
  }, [locations]);
  const handleLocationChange = (value: EmailLocation["id"]) => {
    const selectedLocation = locations.find((loc) => loc.id === value);
    onLocationChange?.(selectedLocation);
  };

  return (
    <div
      className={`${className} p-0`}
      style={{ maxWidth: "500px", width: "100%" }}
    >
      <MUICustomAutocompleteSelect
        label={label}
        name="location-filter"
        options={locationOptions}
        size="large"
        selectProps={{
          onChange: handleLocationChange,
          value: selectedLocation,
        }}
        placeholder="Search.."
        renderOption={(option: LocationOption) => {
          const isSelected =
            selectedLocation &&
            typeof selectedLocation === "object" &&
            selectedLocation.id === option.value;
          return (
            <div className="d-flex justify-content-between align-items-center w-100">
              <span className="small">{option.label}</span>
              {isSelected && <CheckIcon color="primary" fontSize="small" />}
            </div>
          );
        }}
      />
    </div>
  );
};

export default LocationFilter;
